<form [formGroup]="form" class="feedback-body" (ngSubmit)="onSubmit()">
  <p class="section-question blue-text">Your overall satisfaction with the system?</p>

  <div class="rating-section">
    <span class="rating-label-low">very dissatisfied</span>
    <span class="rating-arrow"></span>

    <div class="stars-container" role="radiogroup" aria-label="Rating">
      @for (star of stars; track star) {
        <button
          type="button"
          class="star-button"
          [class.filled]="star <= displayRating()"
          (click)="setRating(star)"
          (mouseenter)="handleStarHover(star)"
          (mouseleave)="handleStarHover(null)"
          role="radio"
          [attr.aria-checked]="star === currentRating()"
          [attr.aria-label]="'Rating ' + star"
        >
          <i class="star-icon fa-solid fa-star" aria-hidden="true"></i>
        </button>
      }
    </div>

    <span class="rating-arrow right"></span>
    <span class="rating-label-high">very satisfied</span>
  </div>

  <div class="divider"></div>

  <div class="options-section">
    <p class="section-title">What do you like BEST?</p>
    <div class="options-row" role="group" aria-label="Select best features">
      @for (option of bestFeatureOptions; track option) {
        <button
          type="button"
          class="options-row-item"
          [class.selected]="selectedBestAspect() === option"
          (click)="toggleBestAspect(option)"
        >
          {{ option }}
        </button>
      }
    </div>
  </div>

  <div class="divider-light"></div>

  <div class="options-section">
    <p class="section-title">What needs the most improvement?</p>
    <div class="options-row" role="group" aria-label="Select improvements">
      @for (option of improvementOptions; track option) {
        <button
          type="button"
          class="options-row-item"
          [class.selected]="selectedNeedsImprovement() === option"
          (click)="toggleNeedsImprovement(option)"
        >
          {{ option }}
        </button>
      }
    </div>
  </div>

  <div class="divider-light"></div>

  <div class="comments-section">
    <label for="comments" class="section-title">Other comments or suggestions:</label>
    <div class="textarea-wrapper">
      <textarea id="comments" formControlName="comments" placeholder="Enter your comment..."></textarea>
    </div>
  </div>

  <div class="feedback-footer">
    <p class="sub-quote">Your feedback is crucial for our growth!</p>
    <button type="submit" class="submit-btn" [disabled]="!isFormValid()">SUBMIT</button>

    <label class="checkbox-wrapper">
      <input type="checkbox" formControlName="isAnonymous" class="checkbox-input" />
      <span class="checkbox-label">Respond Anonymously</span>
    </label>
  </div>
</form>
